"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM = exports.INTERACTIVE = exports.makeFontScale = exports.TYPOGRAPHY = void 0;
var tslib_1 = require("tslib");
exports.TYPOGRAPHY = tslib_1.__importStar(require("./partials/typography"));
var make_font_scale_1 = require("./partials/typography/make-font-scale");
Object.defineProperty(exports, "makeFontScale", { enumerable: true, get: function () { return make_font_scale_1.makeFontScale; } });
exports.INTERACTIVE = tslib_1.__importStar(require("./partials/interactive"));
exports.FORM = tslib_1.__importStar(require("./partials/form"));
//# sourceMappingURL=index.js.map